import {
    ref,
    onMounted
} from 'vue';

import Client from '../services/client';
import Helpers from '../utils/helpers';

const VIDEO_TAG = 'video-tag';
const VIDEO_CATEGORY = 'video-category';

function useHistory () {
    const category = ref(null);

    async function fetchCategory (slug, taxonomy) {
        const { data } = await Client.get(
            `/wp-json/wp/v2/${taxonomy}/?${Helpers.encodeGetParams({ slug }, true)}`,
            {
                headers: { "X-WP-Nonce": window.wp_nonce.nonce },
            }
        );

        if (data.length === 0) {
            return;
        }

        category.value = data[0];
    }

    async function checkReferrerUrl (url, taxonomy) {
        const splitUrl = url.split(`/${taxonomy}/`);

        if (splitUrl.length === 0) {
            return;
        }

        await fetchCategory(splitUrl[1], taxonomy);
    }


    onMounted(async () => {
        const url = document.referrer;

        if (url.includes(VIDEO_CATEGORY)) {
            await checkReferrerUrl(url, VIDEO_CATEGORY);
        }

        if (url.includes(VIDEO_TAG)) {
            await checkReferrerUrl(url, VIDEO_TAG);
        }
    })

    return {
        category
    }
}

export default useHistory;
